import { useShowContext } from 'framework/show';
import { StaffingDataType } from 'domain/shared/staffing';
import { useMenuOptions } from './useMenuOptions';
import { useFollowUpsManagement } from './useFollowUpsManagement';
import { useZonesManagement } from './useZonesManagement';
import { useStaffingCoordinatorManagement } from './useStaffingCoordinatorManagement';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import { useAsyncValue } from 'framework/utils';

export const useStaffingDashboardCallbacks = (refetch?: () => Promise<void>) => {
  const { data } = useShowContext<StaffingDataType>();
  const menuManagement = useMenuOptions();
  const followUpManagement = useFollowUpsManagement(refetch);
  const { zoneOptions, zones, changeZoneCallbacks } = useZonesManagement();
  const { assignCallbacks, assigneeOptions } = useStaffingCoordinatorManagement();
  const { getUserAlias } = useAuthenticatedUserService();
  const currentUserAlias = useAsyncValue(() => getUserAlias());

  const projectData = data?.getData();

  return {
    projectData,
    ...menuManagement,
    ...followUpManagement,
    zoneOptions,
    zones,
    changeZoneCallbacks,
    assignCallbacks,
    assigneeOptions,
    currentUserAlias: currentUserAlias ?? undefined,
  };
};
